<template>
	<div :class="isPC?'tabbar-wrap':''">
		<a v-show="isPC&&(realmName.indexOf('xgzx.talkmed.com')>-1)" href="https://beian.miit.gov.cn">沪ICP备11005620号-15</a>
		<a v-show="isPC&&(realmName.indexOf('vascularnews.cn')>-1)" href="https://beian.miit.gov.cn">沪ICP备11005620号-95</a>
		<van-tabbar v-model="index" @change="switchTab" route>
			<!-- <a href="https://beian.miit.gov.cn">沪ICP备11005620号-15</a> -->
			<van-tabbar-item to="/">
				<img src="../assets/images/Index/home_icon.png" alt="" v-if="index!=0">
				<img src="../assets/images/Index/home_active_icon.png" alt="" v-if="index==0">
				<span :style="{'color':index==0?'#901D22':''}">首页</span>		  	
			</van-tabbar-item>
			<van-tabbar-item to="/meeting/index">
				<img src="../assets/images/Index/meeting_icon.png" alt="" v-if="index!=1">
				<img src="../assets/images/Index/meeting_active_icon.png" alt="" v-if="index==1">
				<span :style="{'color':index==1?'#901D22':''}">会议</span>
			</van-tabbar-item>
			<van-tabbar-item to="/column/index">
				<img src="../assets/images/Index/column_icon.png" alt="" v-if="index!=2">
				<img src="../assets/images/Index/column_active_icon.png" alt="" v-if="index==2">
				<span :style="{'color':index==2?'#901D22':''}">专栏</span>
			</van-tabbar-item>
			<van-tabbar-item to="/personal/index">
				<img src="../assets/images/Index/me_icon.png" alt="" v-if="index!=3">
				<img src="../assets/images/Index/me_active_icon.png" alt="" v-if="index==3">
				<span :style="{'color':index==3?'#901D22':''}">我的</span>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>
<script>
	export default {
	  props:{
	  	active:Number
	  },
	  data() {
	    return {
			 index:this.active?this.active:0,
			 isPC:false,
			 realmName:''
	    }
	  },
	  mounted(){
	  		if(this.ISPC()){
				  	this.isPC=true;
			  }else{
				  this.isPC=false;
			  }
			  this.realmName=window.location.host;
	  },
	  activated(){
	  	this.index=this.active?this.active:0;
	  },
	  methods:{
	  	//切换tab
	  	switchTab(val){
	  		this.index=val
		  },
		ISPC() {  
			var userAgentInfo = navigator.userAgent;  
			var Agents = ['Android', 'iPhone',  
				'SymbianOS', 'Windows Phone',  
				'iPad', 'iPod'  
			];  
			var flag = true;  
			for (var i = 0; i < Agents.length; i++) {  
				if (userAgentInfo.indexOf(Agents[i]) != -1) {  
					flag = false;  
					break;  
				}  
			}  
			return flag;  
   } 

			

	  	}
	}
</script>
<style lang="scss">
.tabbar-wrap{
	height: 75px ;
    position: fixed;
    bottom: 0px;
    left: 0;
    width: 100%;
	a{
		width:100%;
		display:inline-block;
		text-align: center;
		font-size:14px;
		background:#fff;
	}
}
	.van-tabbar{
		height:55px;
		/*padding-bottom:5px;*/
		img{
			width:25px;
			display:block;
			margin-bottom:5px;
		}
		span{
			font-size: 12px;
			margin-bottom:5px;
			color: #999999;
			letter-spacing: 0.42px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Tabbar.vue